module.exports = import("/external-systems-link-ui/assets/remoteEntry.js");